import script from "./JaMaterialAddButton.vue?vue&type=script&setup=true&lang=js"
export * from "./JaMaterialAddButton.vue?vue&type=script&setup=true&lang=js"

import "./JaMaterialAddButton.vue?vue&type=style&index=0&id=d0ea8564&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0ea8564"]])

export default __exports__